import { createContext } from 'react';

const AppContext = createContext({
  TotalProducts: 0,
  user:{}
});


export default AppContext;
